import { MatTableDataSource, MatPaginator, MatSort, MatSnackBar, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { EsteiraService } from './../shared/services/esteira.service';
import { Processo } from '../shared/models/processo.model';
import { ProcessoService } from './../shared/services/processo.service';
import { Esteira } from '../shared/models/esteira.model';
import { Filtro } from '../shared/models/filtro.model';
import { Plano } from '../shared/models/plano.model';
import { PlanoService } from '../shared/services/plano.service';
import { environment } from 'environments/environment';
import { WebProcessoControleService } from '../shared/services/webProcessoControle.service';
import { ViewModelFinalizaProcesso } from '../shared/models/ViewModelFinalizaProcesso.model';
import { ViewModelFiltraProcesso } from '../shared/models/ViewModelFiltraProcesso.model';
import { LoginStore } from '../shared/store/login.store';
import { ModalBeneficiarioDetalhesComponent } from '../detalhes/modal-beneficiario-detalhes/modal-beneficiario-detalhes.component';

@Component({
    selector: "app-esteira",
    templateUrl: "./esteira.component.html",
    styleUrls: ["./esteira.component.scss"],
})
export default class EsteiraComponent implements OnInit {
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    isDateFormat: boolean = environment.isDateFormat;
    lista_Processo: Processo[] = [];
    lista_Esteira: Esteira[] = [];
    lista_Plano: Plano[] = [];
    displayedColumns: string[] = [
        "select",
        "processo",
        "cpf",
        "nome",
        "data",
        "situacao",
        "plano",
        "acoes",
    ];
    selection = new SelectionModel<any>(true, []);
    dataSource = new MatTableDataSource<any>();
    loading = false;

    selectedProcesso: number;
    selectedSituacao: number;
    selectedPlano: number;
    selectedOrderBy: number;

    dataInicio: Date;
    dataFim: Date;

    PostFiltro: ViewModelFiltraProcesso = new ViewModelFiltraProcesso();

    cpf: string = "";
    idPessoaLogada: number;
    constructor(
        private readonly router: Router,
        private processoService: ProcessoService,
        private esteiraService: EsteiraService,
        private planoService: PlanoService,
        private webProcessoControleService: WebProcessoControleService,
        private _snackBar: MatSnackBar,
        private loginStore: LoginStore,
        private dialog: MatDialog
    ) {}

    ngOnInit() {
        this.loginStore.getCurrent().subscribe((retorno) => {
            this.idPessoaLogada = retorno.idPessoa;
        });

        this.dataSource.paginator = this.paginator;

        this.loadPlano();
        this.loadProcesso();
        this.loadEsteira();

        let obj = JSON.parse(localStorage.getItem("search"));

        if (obj != null) {
            this.selectedProcesso = obj.selectedProcesso;
            this.selectedSituacao = obj.selectedSituacao;
            this.selectedPlano = obj.selectedPlano;
            this.dataInicio = obj.dataInicio;
            this.dataFim = obj.dataFim;
            this.selectedOrderBy = obj.selectedOrderBy;
            // this.cpf = obj.cpf;
            // this.applyFilter(obj.cpf);
            this.filtroBuscaAdesao();
        }
    }

    totalPendencia(element: Filtro) {
        if (element.status == 8) return 0;
        if (element.status == 0 || (element.status >= 0 && element.status <= 4))
            return 1;
        if (element.status >= 5 && element.status <= 7) return 2;

        return 0;
    }

    clear() {
        this.selectedProcesso = undefined;
        this.selectedSituacao = undefined;
        this.selectedPlano = undefined;
        this.dataInicio = undefined;
        this.dataFim = undefined;
        //this.selectedOrderBy = undefined;
    }

    filtroBuscaAdesao() {
        // FILTRO ADESÃO
        this.loading = true;
        this.PostFiltro.idProcesso = this.selectedProcesso;
        this.PostFiltro.idStatus = this.selectedSituacao;
        this.PostFiltro.idPlano = this.selectedPlano;
        this.PostFiltro.dtInicio = this.dataInicio;
        this.PostFiltro.dtFim = this.dataFim;
        // this.PostFiltro.selectedOrderBy = this.selectedOrderBy;

        //this.cpf = undefined;

        this.webProcessoControleService
            .FiltraProcesso(this.PostFiltro)
            .subscribe(
                (solicitacoes) => {
                    if (solicitacoes) {
                        //console.log('Resposta do servidor', solicitacoes);
                        this.dataSource = new MatTableDataSource<Filtro>(
                            solicitacoes
                        );
                        this.dataSource.paginator = this.paginator;

                        this.loading = false;
                    } else {
                        console.log("Nenhum dado retornado");
                    }
                },
                (error) => {
                    this.openSnackBarError(
                        "Erro ao realizar a busca!" + error.error,
                        "X"
                    );
                    this.loading = false;
                }
            );
    }

    loadPlano() {
        this.planoService.getAll().subscribe((plano) => {
            this.lista_Plano = plano;
        });
    }

    loadProcesso() {
        this.processoService.getAll().subscribe((processo) => {
            this.lista_Processo = processo.sort(
            (a, b) => a.idProcesso - b.idProcesso
            );
        });
    }

    loadEsteira() {
        this.esteiraService.getAll().subscribe((esteira) => {
            this.lista_Esteira = esteira;
        });
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected == numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: Filtro): string {
        if (!row) {
            return `${this.isAllSelected() ? "select" : "deselect"} all`;
        }
        return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
            row.id + row.idProcesso
        }`;
    }

    // deferirEmprestimo() {
    //     this.spinnerService.show()

    //     let listaProcesso: ViewModelFinalizaProcesso[] = []

    //     this.dataSource.data.map(element => {
    //         if (this.selection.isSelected(element) && element.nomeSituacao == 'PENDENTE') {
    //             console.log(element)
    //             element.nomeSituacao = "DEFERIDO";
    //             listaProcesso.push({
    //                 idContrato: 0,
    //                 idProcesso: element.idProcesso,
    //                 idSolicitacao: element.id
    //             })
    //         }
    //     })

    //     this.dataSource = new MatTableDataSource<Filtro>(this.dataSource.data);
    //     this.dataSource.paginator = this.paginator;

    //     this.webProcessoControleService.DeferirProcessoLista(listaProcesso).subscribe(res => { this.filtroBuscaAdesao() }, error => this.spinnerService.hide())
    // }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 20000,
            panelClass: ["mat-toolbar", "mat-success"],
        });
    }

    openSnackBarError(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 20000,
            panelClass: ["mat-toolbar", "mat-warn"],
        });
    }

    deferir() {
        this.loading = true;
        let dataAtual = new Date();
        var dia = dataAtual.getDate();
        var mes = dataAtual.getMonth() + 1;
        var ano = dataAtual.getFullYear();
        let dataFormatada =
            ano +
            "-" +
            (mes < 10 ? "0" + mes : mes) +
            "-" +
            (dia < 10 ? "0" + dia : dia);

        var date2 = new Date(dataFormatada);

        let listaProcesso: ViewModelFinalizaProcesso[] = [];

        this.selection.selected.forEach((element) => {
            if (element.nomeSituacao == "PENDENTE") {
                if (element.idProcesso == 50) {
                    var data1 = element.dtCredito.substring(0, 10);
                    var date1 = new Date(data1);

                    if (date1 >= date2) {
                        console.log(element);
                        element.nomeSituacao = "DEFERIDO";
                        listaProcesso.push({
                            idContrato:
                                element.idContrato === null
                                    ? 0
                                    : element.idContrato,
                            idProcesso: element.idProcesso,
                            idSolicitacao: element.id,
                            idPessoaLogin: this.idPessoaLogada,
                        });
                    } else {
                        this.openSnackBar(
                            "Contrato referente ao CPF " +
                                element.nrCpf +
                                " não pôde ser deferido! Verifique a data de crédito!",
                            "X"
                        );
                    }
                } else {
                    console.log(element);
                    element.nomeSituacao = "DEFERIDO";
                    listaProcesso.push({
                        idContrato: 0,
                        idProcesso: element.idProcesso,
                        idSolicitacao: element.id,
                        idPessoaLogin: this.idPessoaLogada,
                    });
                }
            }
        });

        this.dataSource = new MatTableDataSource<Filtro>(this.dataSource.data);
        this.dataSource.paginator = this.paginator;
        if (listaProcesso.length > 0) {
            this.webProcessoControleService
                .DeferirProcessoLista(listaProcesso)
                .subscribe(
                    (res) => {
                        this.openSnackBar(
                            "Processo deferido com sucesso!",
                            "X"
                        );
                        this.loading = false;
                        this.filtroBuscaAdesao();
                    },
                    (error) => {
                        this.openSnackBarError(
                            "Erro ao deferido o processo!" + error.error,
                            "X"
                        );
                        this.loading = false;
                    }
                );
        } else {
            this.loading = false;
        }
    }

    indeferir() {
        this.loading = true;

        let listaProcesso: ViewModelFinalizaProcesso[] = [];

        this.dataSource.data.map((element) => {
            if (
                this.selection.isSelected(element) &&
                element.nomeSituacao == "PENDENTE"
            ) {
                console.log(element);
                element.nomeSituacao = "INDEFERIDO";
                listaProcesso.push({
                    idContrato:
                        element.idContrato === null ? 0 : element.idContrato,
                    idProcesso: element.idProcesso,
                    idSolicitacao: element.id,
                    idPessoaLogin: this.idPessoaLogada,
                });
            }
        });

        this.dataSource = new MatTableDataSource<Filtro>(this.dataSource.data);
        this.dataSource.paginator = this.paginator;

        this.webProcessoControleService
            .IndeferirProcessoLista(listaProcesso)
            .subscribe(
                (res) => {
                    this.loading = false;
                    this.filtroBuscaAdesao();
                },
                (error) => {
                    this.loading = false;
                }
            );
    }

    verDetalheEmprestimo(element: Filtro): void {
        console.log("elemnt aqui", element);
        sessionStorage.setItem(
            "detalhesEmprestimoDados",
            JSON.stringify(element)
        );
        this.router.navigate(["detalhesEmprestimo"]);

        localStorage.setItem(
            "search",
            JSON.stringify({
                selectedProcesso: this.selectedProcesso,
                selectedSituacao: this.selectedSituacao,
                selectedPlano: this.selectedPlano,
                dataInicio: this.dataInicio,
                dataFim: this.dataFim,
                cpf: this.cpf,
            })
        );

        localStorage.setItem(
            "searchData",
            JSON.stringify(this.dataSource.data)
        );
    }

    verDetalhe(element: Filtro): void {
        if (element.idProcesso === 3) {
            this.dialog.open(ModalBeneficiarioDetalhesComponent, {
                width: "1500px",
                height: "350px",
                disableClose: true,
                data: { id: element.id },
            });
            this.dialog.afterAllClosed.subscribe(() => {
                this.filtroBuscaAdesao();
            });
            return;
        }
        this.router.navigate(["/detalhes", element], {
            skipLocationChange: true,
        });
        localStorage.setItem(
            "search",
            JSON.stringify({
                selectedProcesso: this.selectedProcesso,
                selectedSituacao: this.selectedSituacao,
                selectedPlano: this.selectedPlano,
                dataInicio: this.dataInicio,
                dataFim: this.dataFim,
                cpf: element.nrCpf,
            })
        );

        localStorage.setItem(
            "searchData",
            JSON.stringify(this.dataSource.data)
        );
    }
}
